export const iframeDrawerContentStyle = { width: '100%', height: '100%', minHeight: 0, flex: 1 };

export const iframeBorderStyle = { border: 'none' };
